import { createAction, props } from '@ngrx/store';
import { ResponseReteterzaReport } from '../../interfaces/response-reteterza-report';
import { RetrieveReteterzaReportPayload } from '../../interfaces/retrieve-reteterza-report-payload';
import { IResponsePuntoPosteDetail } from '../../interfaces/retrive-dettaglio-punto-poste';
import { IResponseReportPuntoPoste } from '../../interfaces/response-report-punto-poste';
import { DownloadDetailReportPostPoint } from '../../interfaces/download-detail-report-post-point';
import { IPayloadPuntoPosteDetail } from '../../interfaces/retrive-report-punto-poste-payload';
import { IThirdPartyReportState } from './third-party-report';
import { ResponseRetiLockerReport } from '../../interfaces/response-reti-locker-report';
import { RetrieveRetilockerReportPayload } from '../../interfaces/retrieve-retiLocker-report-payload';
import {
  IPayloadPuntoPosteLocker,
  IPayloadPuntoPosteLockerDetail,
} from '../../interfaces/retrieve-report-punto-poste-locker-payload';
import { IResponseReportPuntoPosteLocker } from '../../interfaces/response-report-punto-poste-locker';
import { IResponsePuntoPosteLockerDetail } from '../../interfaces/retrieve-punto-poste-locker-detail';
import { DownloadDetailReportPostPointLocker } from '../../interfaces/download-detail-report-post-point-locker';

export const RETRIEVE_RETETERZA_REPORT = createAction(
  '[REPORT RETE TERZA] - retrieve report rete terza',
  props<{ payload: RetrieveReteterzaReportPayload }>()
);

export const RETRIEVE_RETETERZA_REPORT_SUCCESS = createAction(
  '[REPORT RETE TERZA] - retrieve report rete terza success',
  props<{ reteterzaReport: ResponseReteterzaReport | null}>()
);

export const RETRIEVE_RETILOCKER_REPORT = createAction(
  '[REPORT RETI LOCKER] - retrieve report reti locker',
  props<{ payload: RetrieveRetilockerReportPayload }>()
);

export const RETRIEVE_RETILOCKER_REPORT_SUCCESS = createAction(
  '[REPORT RETI LOCKER] - retrieve report reti locker success',
  props<{ retiLockerReport: ResponseRetiLockerReport }>()
);

export const RETRIEVE_REPORT_PUNTO_POSTE_LOCKER = createAction(
  '[REPORT PUNTO POSTE LOCKER] - retrieve report punto poste locker',
  props<{ payload: IPayloadPuntoPosteLocker }>()
);

export const RETRIEVE_REPORT_PUNTO_POSTE_LOCKER_SUCCESS = createAction(
  '[REPORT PUNTO POSTE LOCKER] - retrieve report punto poste success',
  props<{ reponsePuntoPosteLocker: IResponseReportPuntoPosteLocker }>()
);

export const RETRIEVE_DETTAGLIO_PUNTO_POSTE = createAction(
  '[PUNTO POSTE] - retrieve dettaglio punto poste',
  props<{ payload: IPayloadPuntoPosteDetail }>()
);

export const RETRIEVE_DETTAGLIO_PUNTO_POSTE_SUCCESS = createAction(
  '[PUNTO POSTE] - retrieve dettaglio punto poste success',
  props<{ dettaglioPuntoPoste: IResponsePuntoPosteDetail | null }>()
);

export const RETRIEVE_DETTAGLIO_PUNTO_POSTE_LOCKER = createAction(
  '[PUNTO POSTE LOCKER] - retrieve dettaglio punto poste locker',
  props<{ payload: IPayloadPuntoPosteLockerDetail }>()
);

export const RETRIEVE_DETTAGLIO_PUNTO_POSTE_LOCKER_SUCCESS = createAction(
  '[PUNTO POSTE LOCKER] - retrieve dettaglio punto poste locker success',
  props<{ dettaglioPuntoPosteLocker: IResponsePuntoPosteLockerDetail | null }>()
);

export const DOWNLOAD_REPORT_PUNTO_POSTE = createAction(
  '[PUNTO POSTE] - download report punto poste',
  props<{ payload: Partial<IResponsePuntoPosteDetail> }>()
);

export const DOWNLOAD_LISTA_REPORT_PUNTO_POSTE = createAction(
  '[PUNTO POSTE] - download lista report punto poste',
  props<{ payload: Partial<IResponseReportPuntoPoste> }>()
);

export const DOWNLOAD_DETTAGLIO_REPORT_PUNTO_POSTE = createAction(
  '[PUNTO POSTE] - download dettaglio report punto poste',
  props<{ payload: DownloadDetailReportPostPoint }>()
);

export const DOWNLOAD_RETI_TERZE = createAction(
  '[PUNTO POSTE] - download reti terze',
  props<{ payload: Partial<ResponseReteterzaReport> }>()
);

export const DOWNLOAD_RETI_LOCKER = createAction(
  '[PUNTO POSTE LOCKER] - download reti locker',
  props<{ payload: RetrieveRetilockerReportPayload }>()
);

export const DOWNLOAD_DETTAGLIO_REPORT_PUNTO_POSTE_LOCKER = createAction(
  '[PUNTO POSTE LOCKER] - download dettaglio report punto poste locker',
  props<{ payload: DownloadDetailReportPostPointLocker }>()
);

export const DOWNLOAD_LISTA_REPORT_PUNTO_POSTE_LOCKER = createAction(
  '[REPORT LISTA PUNTO POSTE LOCKER] - download report punto poste locker',
  props<{ payload: IPayloadPuntoPosteLocker }>()
);

export const DOWNLOAD_REPORT_PUNTO_POSTE_LOCKER = createAction(
  '[PUNTO POSTE LOCKER] - download lista report punto poste locker',
  props<{ payload: Partial<IResponseReportPuntoPosteLocker> }>()
);

export const RESET_RETE_TERZA_STORE = createAction(
  '[PUNTO POSTE] - reset reti terze'
);
